import React from 'react';

export default class SwitchFlagQuality extends React.Component {

  render() {
    const { flagOrQuality, setFlagOrQuality } = this.props;

    return (
      <div style={{
        position: 'absolute',
        bottom: 170,
        right: 30,
        zIndex: 10,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#FFF',
        borderRadius: 20,
        WebkitBoxShadow: "2px 3px 5px 0px rgba(0,0,0,0.19)",
        MozBoxShadow: "2px 3px 5px 0px rgba(0,0,0,0.19)",
        boxShadow: "2px 3px 5px 0px rgba(0,0,0,0.19)",
      }}>
        <div
          onClick={() => setFlagOrQuality(2)}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            padding: "12px 10px 8px 10px",
            cursor: 'pointer',
          }}>
          <img
            alt='quality'
            style={{
              width: 18,
              height: 22,
              opacity: flagOrQuality === 2 ? 1 : 0.4,
            }}
            src={require('../../assets/icons/icone_quality.png')}
          />
        </div>

        <div style={{ height: 1, background: '#E0E0E0', width: '100%' }} />

        <div
          onClick={() => setFlagOrQuality(3)}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            padding: "10px 10px 10px 10px",
            cursor: 'pointer',
          }}>
          <img
            alt='ostreopsis'
            style={{
              width: 18,
              height: 22,
              opacity: flagOrQuality === 3 ? 1 : 0.4,
            }}
            src={require('../../assets/icons/icone_ostreopsis.png')}
          />
        </div>

        <div style={{ height: 1, background: '#E0E0E0', width: '100%' }} />

        <div
          onClick={() => setFlagOrQuality(1)}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            padding: "8px 10px 12px 10px",
            cursor: 'pointer',
          }}>
          <img
            alt='flag'
            style={{
              width: 20,
              height: 23,
              opacity: flagOrQuality === 1 ? 1 : 0.4,
            }}
            src={require('../../assets/icons/icone_flag.png')}
          />
        </div>
      </div>
    );
  }
}
